module.exports = __webpack_public_path__ + "img/food1.f9c27173.jpg";